import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'
import { IAuthAction, IAuthState } from '@/services/landing/auth-store'

const useAuthStore = create(
  persist<IAuthState & IAuthAction>(
    (set) => ({
      // State
      phoneNumber: '',
      otp: '',
      accessToken: null,
      refreshToken: null,
      message: null,
      error: null,
      errorType: null,
      showOtpModal: false,
      timerStartTimestamp: 0,
      contractType: null,
      lastStep: 0,

      // Actions
      setPhoneNumber: (phoneNumber) => set({ phoneNumber }),
      setOtp: (otp) => set({ otp }),
      setTokens: (accessToken) => set({ accessToken }),
      setLastStep: (lastStep) => set({ lastStep }),
      setMessage: (message) => set({ message }),
      setShowOtpModal: (isOpen) => set({ showOtpModal: isOpen }),
      setTimerStartTimestamp: (timestamp) =>
        set({ timerStartTimestamp: timestamp }),
      setError: (error, errorType) => set({ error, errorType }),
      setContractType: (contractType) => set({ contractType }),
      clearAuth: () =>
        set({
          phoneNumber: '',
          otp: '',
          accessToken: null,
          refreshToken: null,
          message: null,
          error: null,
          errorType: null,
          showOtpModal: false,
          contractType: null,
          lastStep: null
        })
    }),
    {
      name: 'auth-storage',
      storage: createJSONStorage(() => localStorage)
    }
  )
)

export default useAuthStore
